// extracted by mini-css-extract-plugin
module.exports = {"headerImageFrame":"y-","headerImage":"y_"};